import { Checkbox } from "@/components/ui/checkbox";

const ITEMS = [
  ["doc_complete", "Dokumen Persyaratan Lengkap", "checklist-doc-complete"],
  ["norek_match", "Nomor Rekening Sesuai antara Data dan Buku", "checklist-norek-match"],
  ["namarek_match", "Nama Rekening Sesuai antara Data dan Buku", "checklist-namarek-match"],
  ["handover_complete", "Buku Tabungan dan ATM telah diserahkan dan diterima mahasiswa dengan baik", "checklist-handover-complete"],
];

export const MantabServiceChecklist = ({ values, onChange }) => <section className="mantab-service-checklist">
  <h2 data-testid="checklist-section-header">Pastikan Chek List sudah sesuai dengan data mahasiswa ini:</h2>
  <div>{ITEMS.map(([id, label, testId], index) => <label key={id} className={values[id] ? "checked" : ""}><Checkbox checked={values[id]} onCheckedChange={(checked) => onChange(id, checked === true)} data-testid={testId} /><span><em>{String(index + 1).padStart(2, "0")}</em>{label}</span></label>)}</div>
</section>;